export const ActionTypes = {
  LOADING: "MY_CLIENTS_LIST_LOADING",
  ERROR: "MY_CLIENTS_LIST_ERROR",
  SUCCESS: "MY_CLIENTS_LIST_SUCCESS"
};
